var React = require('react');

function DownloadIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.48 10.257V.917a.687.687 0 1 1 1.374 0v9.34l3.41-3.41a.687.687 0 1 1 .972.972l-4.583 4.584a.688.688 0 0 1-.972 0L4.097 7.819a.688.688 0 0 1 .972-.972l3.41 3.41zm8.25-.174a.687.687 0 0 1 1.374 0v3.667a2.52 2.52 0 0 1-2.52 2.52H2.75a2.52 2.52 0 0 1-2.52-2.52v-3.667a.687.687 0 0 1 1.374 0v3.667c0 .633.513 1.146 1.146 1.146h12.833c.633 0 1.146-.513 1.146-1.146v-3.667z"}));
}

DownloadIcon.displayName = "DownloadIcon";

DownloadIcon.defaultProps = {"viewBox":"0 0 18 17"};

module.exports = DownloadIcon;

DownloadIcon.default = DownloadIcon;
